import { render, staticRenderFns } from "./HandlerSelector.vue?vue&type=template&id=2f0eb131&"
import script from "./HandlerSelector.vue?vue&type=script&lang=js&"
export * from "./HandlerSelector.vue?vue&type=script&lang=js&"
import style0 from "./HandlerSelector.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports